import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import type { BindGateRequest, ValidateOccupantRequest } from '../model/gateSessionDto';
import { BaseService } from '../../core/api.base.service';
import { Configuration } from '../../core/configuration';
import { BASE_PATH } from '../../core/variables';
import { environment } from '../../../environments/environment';

/** Facility field-ops gate session APIs (stub — wire when backend is ready). */
@Injectable({ providedIn: 'root' })
export class GateSessionControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath ?? environment.facilityApiUrl, configuration);
  }

  getGateDutyContext(
    organizationId: number,
    projectId: number,
    options?: { context?: HttpContext },
  ): Observable<unknown> {
    return this.request(
      'get',
      '/v1/facility/vendor-portal/gate-duty',
      { projectId: String(projectId) },
      null,
      options,
      organizationId,
    );
  }

  bindGate(
    organizationId: number,
    body: BindGateRequest,
    options?: { context?: HttpContext },
  ): Observable<unknown> {
    return this.request(
      'post',
      '/v1/facility/vendor-portal/gate-sessions/bind',
      null,
      body,
      options,
      organizationId,
    );
  }

  validateOccupant(
    organizationId: number,
    body: ValidateOccupantRequest,
    options?: { context?: HttpContext },
  ): Observable<unknown> {
    return this.request(
      'post',
      '/v1/facility/vendor-portal/gate-sessions/validate-occupant',
      null,
      body,
      options,
      organizationId,
    );
  }

  private request(
    method: string,
    path: string,
    params: Record<string, string> | null,
    body: unknown,
    options?: { context?: HttpContext },
    organizationId?: number,
  ): Observable<unknown> {
    let headers = this.defaultHeaders;
    headers = this.configuration.addCredentialToHeaders('bearer', 'Authorization', headers);
    if (organizationId != null && organizationId > 0) {
      headers = headers.set('X-Organization-Id', String(organizationId));
    }
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request(method, `${basePath}${path}`, {
      context: options?.context,
      body,
      params: params ?? undefined,
      ...(withCredentials ? { withCredentials } : {}),
      headers,
      observe: 'body',
    });
  }
}
